class TopLoading {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const topLoading = document.querySelector(".topLoading");
    const header = document.querySelector(".l-header");
    const sideTxt = document.querySelector(".sideTxt");
    const humMenu = document.querySelector(".js-hum");
    const mv = document.querySelector(".s-mv");

    setTimeout(() => {
      topLoading.classList.add("is-open");
    },500);

    setTimeout(() => {
      header.classList.add("is-open");
    },1300);

    setTimeout(() => {
      humMenu.classList.add("is-open");
    },1300);

    setTimeout(() => {
      sideTxt.classList.add("is-open");
    },1300);

    setTimeout(() => {
      mv.classList.add("is-open");
    },1500);
  }
}